/** Clear all client-side session keys used by the admin SPA. */
export function clearSession() {
  [
    "adminToken",
    "adminUser",
    "isAdminLoggedIn",
    "requirePasswordChange",
    "email",
  ].forEach((k) => localStorage.removeItem(k));
}

/** Sign out: revoke server session when possible, then clear local state. */
export async function logoutSession(api) {
  try {
    if (api && localStorage.getItem("adminToken")) {
      await api.post("/undertaking/dashboard/logout");
    }
  } catch {
    /* still clear locally */
  }
  clearSession();
}

export default clearSession;
